<template>
  <div>
    <b-tabs>
      <div class="loading_page" v-if="loading">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
      <b-tab>
        <template #title>
          <feather-icon icon="UserIcon" />
          <span>{{ $t('Wasl Information') }}</span>
        </template>

        <b-form class="repeater-form" style="overflow: visible;">


          <!-- Field: wasl fields -->
          <b-row>

            <b-col cols="12" md="6">
              <b-form-group :label="$t('Identity Number')" label-for="identityNumber">
                <b-form-input id="identityNumber" v-model="form.identityNumber" :disabled="$store.state.appUser.data.wasl" />
                <small v-if="errors && ('identityNumber' in errors)" class="text-danger">
                  {{ $t(errors['identityNumber'][0]) }}
                </small>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group :label="$t('commercial Record Number')" label-for="commercialRecordNumber">
                <b-form-input id="commercialRecordNumber" :state="null" v-model="form.commercialRecordNumber"
                :disabled="$store.state.appUser.data.wasl" />
                <small v-if="errors && ('commercialRecordNumber' in errors)" class="text-danger">
                  {{ $t(errors['commercialRecordNumber'][0]) }}
                </small>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group :label="$t('commercial Record Issue Date Hijri')+' e.g (1410-07-01)'"
                label-for="commercialRecordIssueDateHijri">
                <b-form-input id="commercialRecordIssueDateHijri"
                   :state="null"
                   placeholder="14010-07-01"
                  v-model="form.commercialRecordIssueDateHijri" :disabled="$store.state.appUser.data.wasl" />
                <small v-if="errors && ('commercialRecordIssueDateHijri' in errors)" class="text-danger">
                  {{ $t(errors['commercialRecordIssueDateHijri'][0]) }}
                </small>
              </b-form-group>
            </b-col>


            <b-col cols="12" md="6">
              <b-form-group :label="$t('phone number')" label-for="phoneNumber">
                <b-form-input id="phoneNumber" v-model="form.phoneNumber" :state="null" :disabled="$store.state.appUser.data.wasl" />
                <small v-if="errors && ('phoneNumber' in errors)" class="text-danger">
                  {{ $t(errors['phoneNumber'][0]) }}
                </small>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group :label="$t('email address')" label-for="emailAddress">
                <b-form-input id="emailAddress" v-model="form.emailAddress" :state="null" :disabled="$store.state.appUser.data.wasl" />
                <small v-if="errors && ('emailAddress' in errors)" class="text-danger">
                  {{ $t(errors['emailAddress'][0]) }}
                </small>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group :label="$t('manager name')" label-for="managerName">
                <b-form-input id="managerName" v-model="form.managerName" :state="null" />
                <small v-if="errors && ('managerName' in errors)" class="text-danger">
                  {{ $t(errors['managerName'][0]) }}
                </small>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group :label="$t('manager phone number')" label-for="managerPhoneNumber">
                <b-form-input id="managerPhoneNumber" :state="null" v-model="form.managerPhoneNumber" />

                <small v-if="errors && ('managerPhoneNumber' in errors)" class="text-danger">
                  {{ $t(errors['managerPhoneNumber'][0]) }}
                </small>

              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group :label="$t('manager mobile number')" label-for="managerMobileNumber">
                <b-form-input id="managerMobileNumber" v-model="form.managerMobileNumber" :state="null" />
                <!--            <small v-if="form.errors.has('managerMobileNumber')" class="text-danger">-->
                <!--              {{ $t(form.errors.get('managerMobileNumber')) }}-->
                <!--            </small>-->
              </b-form-group>
            </b-col>






          </b-row>






          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" @click="saveWaslInof('save')"
            variant="primary" class="mr-1">
            {{ $t($store.state.appUser.data.wasl ? 'update' : 'register') }}
          </b-button>


          <b-button v-if="$store.state.appUser.data.wasl" v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button"
            @click="deleteWasl()" variant="danger" class="mr-1">
            {{ $t('Delete') }}
          </b-button>

        </b-form>
      </b-tab>

      <b-tab v-if="$store.state.appUser.data.wasl" @click="saveWaslInof('getInfo')">
        <template #title>
          <feather-icon icon="InfoIcon" />
          <span>{{ $t('Wasl Status') }}</span>
        </template>

        <div class="mt-5" v-if="Object.keys(waslStatusData).length !== 0">

          <app-timeline>

            <app-timeline-item :title="$t('name')" :subtitle="waslStatusData.name" icon="InfoIcon" variant="success" />

            <app-timeline-item :title="$t('Registration Date')" :subtitle="waslStatusData.registrationDate"
              icon="InfoIcon" variant="success" />

            <app-timeline-item :title="$t('Is Valid')" :subtitle="waslStatusData.isValid.toString()" icon="InfoIcon"
              variant="success" />
          </app-timeline>


        </div>
      </b-tab>


    </b-tabs>




  </div>

</template>

<script>

import {
  BButton, BCol,
  BFormGroup,
  BFormInput,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BForm, BTabs, BTab, BCardText
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { ref, onMounted, on, onUnmounted, computed, reactive } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'




export default {
  props: {
    userData: {
      type: Object,
      required: true
    },

  },
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BForm,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    vSelect,
    OrbitSpinner, BTabs, BTab, BCardText,
    AppTimeline,
    AppTimelineItem,
  },

  setup(props, { root }) {
    const s = store.state.appUser
    const errors = ref({})
    let type = "companyRegistration";
    const waslStatusData = ref({})
    const form = ref({})
    const loading = ref(false)

    Object.assign(form.value, { wasl: store.state.appUser.data.wasl, ...props.userData.company })



    const deleteWasl = id => {

      root.$swal({
        title: root.$i18n.t("Are You Sure"),
        text: root.$i18n.t("Do you want to delete vehicle from wasl?"),
        showCancelButton: true,
        confirmButtonText: root.$i18n.t('Delete'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          saveWaslInof('delete')

        }
      })
    }




    const saveWaslInof = (actionType) => {


      loading.value = true;
      let wasl = store.state.appUser.data.wasl;
      if (wasl == true) { type = "companyUpdate" }

      if (wasl == false) { type = "companyRegistration" }
      if (actionType == "delete") { type = "companyDelete" }
      if (actionType == "getInfo") { type = "companyInquiry" }
      const waslRegisterRequest = ref({
        "type": type,
        "user_id": props.userData.id,
        "identityNumber": form.value.identityNumber,
        "commercialRecordNumber": form.value.commercialRecordNumber,
        "commercialRecordIssueDateHijri": form.value.commercialRecordNumber,
        "phoneNumber": form.value.phoneNumber,
        "emailAddress": form.value.emailAddress,
        "managerName": form.value.managerName,
        "managerPhoneNumber": form.value.managerPhoneNumber,
        "managerMobileNumber": form.value.managerMobileNumber,
        "activity": "DEFAULT"


      });

      store.dispatch('appUser/saveWaslData', waslRegisterRequest.value)
        .then(res => {
          loading.value = false;
          errors.value = null;
          if (type !== "companyInquiry") {
            root.$bvToast.toast(
              root.$i18n.t("sucess"), {
              title: `Success`,
              variant: 'success',
            })
          } else {
            waslStatusData.value = res.data
          }

        }).catch((error) => {
          loading.value = false;
          if (error.response.status == 422) {
            errors.value = error.response.data
          }


        }).finally(() => {
          loading.value = false;
        })

     

    }
    const plateTypesOptions = [
      { code: 1, en: "Private Car", ar: "خصوصي" },
      { code: 2, en: "Public Transport", ar: "نقل عام" },
      { code: 3, en: "Private Transport", ar: "نقل خاص" },
      { code: 4, en: "Public Bus", ar: "حافلة صغيرة عامة" },
      { code: 5, en: "Private Bus", ar: "حافلة صغيرة خاصة" },
      { code: 6, en: "Taxi", ar: "اجرة" },
      { code: 7, en: "Heavy Equipment", ar: "معدات ثقيلة" },
      { code: 8, en: "Export", ar: "تصدير" },
      { code: 9, en: "Diplomatic", ar: "دبلوماسي" },
      { code: 10, en: "Motorcycle", ar: "دراجة نارية" },
      { code: 11, en: "Temporary", ar: "مؤقت" },
    ]

    return {
      saveWaslInof,
      plateTypesOptions,
      errors,
      deleteWasl,
      waslStatusData,
      form, loading

    }
  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

.custom-timeline,
.d-flex.flex-sm-row.flex-column.flex-wrap.justify-content-between.mb-1.mb-sm-0 h6 {
  font-size: 19px;
  font-style: oblique;
  font-weight: bold;
}
</style>
